import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { TitledBody } from '../../common/components/TitledBody'
import { SectionedForm } from '../../common/components/SectionedForm'
import { Grid } from '@mui/material'
import { useGeneralSection } from './general'
import { usePrivilege } from '../../common/util/hooks'
import { FeaturePrivileges } from '../../common/util/featurePrivileges'

export const DetailNightService = () => {
    const { t } = useTranslation()
    const { hasAccess: hasWriteAccess } = usePrivilege(FeaturePrivileges.emergencyDivert.write)

    const generalSection = useGeneralSection();
    const formSections = useMemo(() => [
        generalSection
    ], [generalSection])

    return (
        <TitledBody title={t('navigation.night-service')} >
            <Grid container>
                <Grid item xs={12} lg={10}>
                    <SectionedForm formSections={formSections} activeTab={0} readOnly={!hasWriteAccess}/>
                </Grid>
            </Grid>
        </TitledBody>
    )
}
